import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_match_card = _resolveComponent("match-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_count_down = _resolveComponent("count-down")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_tournament_brackets = _resolveComponent("tournament-brackets")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
                _createTextVNode(" Tournament "),
                _createElementVNode("span", null, _toDisplayString(_ctx.tournament.name), 1)
              ]))
            : (_openBlock(), _createElementBlock("h1", _hoisted_2, [
                _createVNode(_component_v_skeleton_loader, {
                  "min-width": "300",
                  "max-width": "300",
                  type: "subtitle"
                })
              ]))
        ]),
        _: 1
      }),
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_match_card)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3"
              }, {
                default: _withCtx(() => [
                  (_ctx.tournament && _ctx.tournament.status != 'ended')
                    ? (_openBlock(), _createBlock(_component_count_down, { key: 0 }))
                    : (_ctx.tournament.status === 'ended')
                      ? (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode("ENDED")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Winner: "),
                                _createVNode(_component_v_img, {
                                  height: "60px",
                                  src: _ctx.tournament.positions[_ctx.tournament.positions.length - 1].player.avatar
                                }, null, 8, ["src"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_skeleton_loader, {
                    "max-width": "300",
                    type: "image"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_skeleton_loader, {
                    "max-width": "300",
                    type: "image"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col)
            ]),
            _: 1
          })),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_ctx.loaded)
            ? (_openBlock(), _createBlock(_component_tournament_brackets, {
                key: 0,
                tournament: _ctx.tournament
              }, null, 8, ["tournament"]))
            : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 1,
                type: "table-row,table-row,table-row,table-row,table-row,table-row,table-row"
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}